import { cn } from '../../lib/cn';

const SIZES = {
  sm: 'h-7 w-7 text-[10px]',
  md: 'h-9 w-9 text-xs',
  lg: 'h-11 w-11 text-sm',
  xl: 'h-14 w-14 text-base',
};

export function Avatar({
  className,
  src,
  alt,
  fallback,
  icon: Icon,
  size = 'md',
  variant = 'default',
  style,
  ...props
}) {
  function variantStyle() {
    switch (variant) {
      case 'primary':
        return {
          background: 'var(--dash-primary-soft)',
          color: 'var(--dash-primary)',
          border: '1px solid var(--dash-primary-border)',
        };
      case 'success':
        return {
          background: 'rgba(52,254,173,0.12)',
          color: '#1fb37c',
          border: '1px solid rgba(52,254,173,0.3)',
        };
      case 'warning':
        return {
          background: 'rgba(254,173,52,0.12)',
          color: '#c47b00',
          border: '1px solid rgba(254,173,52,0.3)',
        };
      case 'danger':
        return {
          background: 'rgba(254,52,86,0.12)',
          color: '#d61f3f',
          border: '1px solid rgba(254,52,86,0.3)',
        };
      default:
        return {
          background: 'var(--dash-surface-subtle)',
          color: 'var(--dash-text-soft)',
          border: '1px solid var(--dash-border)',
        };
    }
  }

  return (
    <div
      className={cn(
        'flex shrink-0 items-center justify-center overflow-hidden rounded-xl font-semibold',
        SIZES[size],
        className
      )}
      style={{ ...variantStyle(), ...style }}
      {...props}
    >
      {src ? (
        <img src={src} alt={alt} className="h-full w-full object-cover" />
      ) : Icon ? (
        <Icon size={size === 'sm' ? 13 : size === 'md' ? 16 : 20} strokeWidth={2.2} />
      ) : (
        fallback
      )}
    </div>
  );
}
